import React, { useState } from "react";
import CurrencyInput from "./CurrencyInput";
import styles from "./ClientForm.module.css";

function Liabilities({ formData, setFormData, prevStep, nextStep }) {
  const [liabilities, setLiabilities] = useState(
    formData.liabilities.length > 0 ? formData.liabilities : [{ type: "", balance: "", repayment: "" }]
  );

  const updateLiability = (index, field, value) => {
    const updated = [...liabilities];
    updated[index][field] = value;
    setLiabilities(updated);
    setFormData({ ...formData, liabilities: updated });
  };

  const addLiability = () => {
    setLiabilities([...liabilities, { type: "", balance: "", repayment: "" }]);
  };

  const removeLiability = (index) => {
    const updated = liabilities.filter((_, i) => i !== index);
    setLiabilities(updated);
    setFormData({ ...formData, liabilities: updated });
  };

  return (
    <div className={styles.container}>
      <h3>Liabilities</h3>
      <p>Select any existing debts or obligations:</p>

      {liabilities.map((liability, index) => (
        <div key={index} className={styles.formRow}>
          <select
            value={liability.type}
            onChange={(e) => updateLiability(index, "type", e.target.value)}
          >
            <option value="">Select Liability</option>
            <option value="Credit Card">Credit Card</option>
            <option value="Personal Loan">Personal Loan</option>
            <option value="Home Loan">Home Loan</option>
            <option value="HECS/HELP Debt">HECS/HELP Debt</option>
            <option value="Car Loan">Car Loan</option>
          </select>

          {/* Show inputs dynamically */}
          {liability.type === "Credit Card" ? (
            <CurrencyInput
              value={liability.limit}
              onChange={(val) => updateLiability(index, "limit", val)}
              placeholder="Card Limit ($)"
            />
          ) : liability.type ? (
            <>
              <CurrencyInput
                value={liability.balance}
                onChange={(val) => updateLiability(index, "balance", val)}
                placeholder="Current Balance ($)"
              />
              <CurrencyInput
                value={liability.repayment}
                onChange={(val) => updateLiability(index, "repayment", val)}
                placeholder="Monthly Repayment ($)"
              />
            </>
          ) : null}

          <button
            type="button"
            className={styles.removeBtn}
            onClick={() => removeLiability(index)}
          >
            ✕
          </button>
        </div>
      ))}

      <button type="button" className={styles.addBtn} onClick={addLiability}>
        + Add Liability
      </button>

      <div className={styles.navBtns}>
        <button className={styles.nextBtn} onClick={prevStep}>
          ← Back
        </button>
        <button className={styles.nextBtn} onClick={nextStep}>
          Submit Application
        </button>
      </div>
    </div>
  );
}

export default Liabilities;
